import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyImport } from "owa-bundling";

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "TabbedSearch"*/ "./lazyIndex"), { name: "TabbedSearch" });

export const lazySetShouldSuppressTabs: LazyImport<typeof lazyIndex.setShouldSuppressTabs, typeof lazyModule> = new LazyImport(lazyModule, m => m.setShouldSuppressTabs);
